export default __webpack_public_path__ + "static/media/O-004.40f53de9.png";